<template>
  <div class="list-table">
    <Loader v-if="loading" cover />
    <!-- <div class="status" v-if="status.active">{{ status.message }}</div> -->
    <vs-table
      :data="list"
      :noDataText="status.message"
      class="table"
    >
      <template slot="header">
        <div class="table-header"></div>
      </template>

      <template slot="thead"
        v-for="(thead, indexth) in table.header"
      >
        <vs-th :key="indexth">
          {{ thead.title }}
        </vs-th>
      </template>

      <template
        slot-scope="{data}"
        class="table-body"
      >
        <vs-tr
          :data="{ data: tr, index: indextr }"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td width="40">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td>
            {{ tr.nameLocal }}
          </vs-td>

          <vs-td width="80">
            {{ tr.score }}
          </vs-td>

          <vs-td width="80">
            <!-- :alt="tr.questionType.nameLocal" -->
            {{ tr.questionTypeCode }}
          </vs-td>

          <vs-td width="50">
            {{ tr.unitSeq }}
          </vs-td>

          <vs-td class="whitespace-no-wrap" width="100">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="handleEdit(tr)" />

            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.prevent="handleDelete(tr)" />
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { state } from "../data";
import template from "../data/data-template";
import { handleEdit, handleDeleteListItem } from "../data/data-handlers";

export default {
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue')
  },
  data() {
    return {
      store: state.store,
      table: template.table,
    }
  },
  computed: {
    loading() {
      return state.local.loading.list;
    },
    status() {
      return state.local.status.list;
    },
    list() {
      return state.local.list;
    }
  },
  methods: {
    handleEdit(data) {
      handleEdit(data);
    },
    async handleDelete(tr) {
      await handleDeleteListItem(tr);
    },
    // totalLength(s) {
    //   if (s) {
    //     return  timeLengthFormat(s);
    //   }
    //   return "unknown"
    // }
  },
  mounted() {
    // this.getList();
  }
}
</script>

<style lang="scss" scoped>
.list-table {
  width: 100%;
  height: auto;
  position: relative;

  & .table {
    width: 100% !important;
  }
}
</style>
